export default {
    loadInitialItemsFromServerError: {
        datapoint: {
            name: 'TnS_InitialLoadItemsError',
            customData: function (responseCode) { return [responseCode]; },
        },
    },
    loadMoreRowsFromServerError: {
        datapoint: {
            name: 'TnS_LoadMoreRowsError',
            customData: function (listViewType, responseCode) { return [
                listViewType,
                responseCode,
            ]; },
        },
    },
    reloadTable: {
        datapoint: {
            name: 'ReloadTable',
            customData: function (rowsToReload) { return [rowsToReload]; },
        },
    },
    reloadTableServerError: {
        datapoint: {
            name: 'TnS_ReloadError',
            customData: function (responseCode) { return [responseCode]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map